<template>
  <div class="sign-up-header">
    <div v-if="!sending" class="reset_password">
      <h2>Forget Password ?</h2>
      <p class="message">let us know your email and we'll send you link to reset your password</p>
      <div class="card mx-auto">
        <!-- body -->
        <form @submit.prevent="sendPasswordReset">
          <label class="form-group pure-material-textfield-outlined">
            <input
              v-model="email"
              type="email"
              v-bind:class="['form-control', 'validate', { error: email_message.length }]"
              id="login_email1"
              placeholder=" "
            />
            <span>Email</span>
            <p class="error-message">{{email_message || "&nbsp;"}}</p>
          </label>
          <div class="form-group">
            <button
              v-on:click="verificationSent = false"
              type="submit"
              class="btn btn-info btn-block"
              style="white-space: normal"
            >Send Email</button>
            <div class="login_section">
              <span>or</span>
              <router-link :to="'/signin'" class="login">Log in</router-link>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div v-else>
      <div class="card mx-auto" style="marginTop: 6rem;">
        <p style="textAlign: center; font-size: 1.5rem;">A link has been sent to your email</p>
        <v-icon
          name="check"
          style="height: 3rem; backgroundColor: #16abbd; margin: 1rem auto;
            marginTop: 1.5rem; border-radius: 25px; color:white; border: 4px #16abbd solid"
        ></v-icon>
      </div>
    </div>
  </div>
</template>

<script >
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  components: {
    PulseLoader
  },
  data() {
    return {
      email: "",
      email_message: "",
      sending: false,
      passwordResetSent: false,

      color: "white",
      size: "10px"
    };
  },
  methods: {
    sendPasswordReset() {
      this.email_message = "";
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      this.sending = true;
      const vm = this;

      if (!re.test(String(this.email))) {
        this.email_message = "*Invalid email format";
      } else {
        this.$store
          .dispatch("sendPasswordReset", this.email)
          .then(message => {
            this.email_message = "A link has been sent to your email";
            this.sending = true;
          })
          .catch(err => {
            console.log(err.response);
            this.email_message = err.response.data.message;
          });
      }
      this.sending = false;
    }
  }
};
</script>

<style scoped lang="css" >
body {
  font-family: Arial, Helvetica, sans-serif;
}

.sign-up-header {
  padding: 5%;
  background: white;
  /* min-height: 800px; */
  /* color: white; */
}

.login_section {
  text-align: center;
}

.login_section > span {
  padding: 0.3rem;
}

.reset_password {
  margin-top: 2rem;
  text-align: center;
}

h2 {
  margin-top: 5%;
  margin: auto;
  padding: 1rem;
  font-size: 2rem;
  font-weight: bold;
  font-family: Helvetica;
  text-align: center;
  width: 450px;
}

.description {
  padding-bottom: 2em;
}

.card {
  background-color: white !important;
  margin: 25px;
  padding: 30px 0;
  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.21),
    0 5px 15px 0 rgba(0, 0, 0, 0.08);
  /* transition: all 0.5s; */
  width: 600px;
  float: none;
  border-radius: 15px;
}

.footer {
  text-align: center;
  font-style: italic;
}

.form-control {
  margin-bottom: 15px;
}

.error-message {
  font-size: 80%;
  color: red;
  text-align: left;
}

.btn-info {
  font-weight: bold;
  width: 60%;
  margin: 3rem auto;
}

.form-check-label {
  margin-bottom: 10px;
  font-size: 80%;
}

.form-check {
  margin-top: -15px;
  margin-bottom: 10px;
}

.form-check-input {
  margin-left: 0px;
}

.form-check-label {
  margin-left: 0.5rem;
}

.login {
  margin-top: 0.5rem;
  font-size: 1rem;
  font-weight: bold;
  border: none;
  color: #16abbd;
  cursor: pointer;
}

.pure-material-textfield-outlined {
  /* --pure-material-safari-helper1: rgb(var(--pure-material-primary-rgb, 33, 150, 243)); */
  position: relative;
  width: 60%;
  margin: 25px auto;
  display: block;
  padding-top: 6px;
  font-family: var(
    --pure-material-font,
    "Roboto",
    "Segoe UI",
    BlinkMacSystemFont,
    system-ui,
    -apple-system
  );
  font-size: 16px;
  margin-bottom: 0 !important;
  line-height: 1.5;
  overflow: hidden;
}

/* Input, Textarea */
.pure-material-textfield-outlined > input {
  box-sizing: border-box;
  margin: 0;
  border: solid 1px; /* Safari */
  border-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.2);
  border-top-color: transparent;
  border-radius: 4px;
  width: 100%;
  height: inherit;
  color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.8);
  background-color: transparent;
  box-shadow: none; /* Firefox */
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  caret-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243));
  transition: border 0.2s, box-shadow 0.2s;
}

/* Span */
.pure-material-textfield-outlined > input + span {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  border-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.2);
  width: 100%;
  max-height: 100%;
  color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  font-size: 75%;
  line-height: 15px;
  cursor: text;
  transition: color 0.2s, font-size 0.2s, line-height 0.2s;
}

/* Corners */
.pure-material-textfield-outlined > input + span::before,
.pure-material-textfield-outlined > input + span::after {
  content: "";
  display: block;
  box-sizing: border-box;
  margin-top: 6px;
  border-top: solid 1px;
  border-top-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  min-width: 10px;
  height: 8px;
  pointer-events: none;
  box-shadow: inset 0 1px transparent;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.pure-material-textfield-outlined > input + span::before {
  margin-right: 4px;
  border-left: solid 1px transparent;
  border-radius: 4px 0;
}

.pure-material-textfield-outlined > input + span::after {
  flex-grow: 1;
  margin-left: 4px;
  border-right: solid 1px transparent;
  border-radius: 0 4px;
}

/* Placeholder-shown */
.pure-material-textfield-outlined > input:not(:focus):placeholder-shown {
  border-top-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.2);
}

.pure-material-textfield-outlined > input:not(:focus):placeholder-shown + span {
  font-size: inherit;
  line-height: 50px;
}

.pure-material-textfield-outlined
  > input:not(:focus):placeholder-shown
  + span::before,
.pure-material-textfield-outlined
  > input:not(:focus):placeholder-shown
  + span::after {
  border-top-color: transparent;
}

/* Focus */
.pure-material-textfield-outlined > input:focus {
  border-color: #16abbd;
  border-top-color: transparent;
  box-shadow: inset 1px 0 var(--pure-material-safari-helper1),
    inset -1px 0 var(--pure-material-safari-helper1),
    inset 0 -1px var(--pure-material-safari-helper1);
  outline: none;
}

.pure-material-textfield-outlined > input:focus + span {
  border-color: #16abbd;
}

.pure-material-textfield-outlined > input:focus + span::before,
.pure-material-textfield-outlined > input:focus + span::after {
  border-top-color: #16abbd !important;
  box-shadow: inset 0 1px var(--pure-material-safari-helper1);
}

/* error */
.pure-material-textfield-outlined > input.error,
.pure-material-textfield-outlined > input.error + span {
  border-color: red !important;
  border-top-color: transparent !important;
}

.pure-material-textfield-outlined > input.error + span::before,
.pure-material-textfield-outlined > input.error + span::after {
  border-top-color: red !important;
}

.pure-material-textfield-outlined > input.error:placeholder-shown,
.pure-material-textfield-outlined > input.error:placeholder-shown + span {
  border-top-color: red !important;
}

.pure-material-textfield-outlined
  > input.error:placeholder-shown
  + span::before,
.pure-material-textfield-outlined
  > input.error:placeholder-shown
  + span::after {
  border-top-color: transparent !important;
}

/* Error && Focus */
.pure-material-textfield-outlined > input.error:focus {
  border-color: red;
  border-top-color: transparent !important;
  box-shadow: inset 1px 0 var(--pure-material-safari-helper1),
    inset -1px 0 var(--pure-material-safari-helper1),
    inset 0 -1px var(--pure-material-safari-helper1);
  outline: none;
}

.pure-material-textfield-outlined > input.error:focus + span::before,
.pure-material-textfield-outlined > input.error:focus + span::after {
  border-top-color: red !important;
  box-shadow: inset 0 1px var(--pure-material-safari-helper1);
}

/* Faster transition in Safari for less noticable fractional font-size issue */
@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) {
    .pure-material-textfield-outlined > input,
    .pure-material-textfield-outlined > input + span,
    .pure-material-textfield-outlined > input + span::before,
    .pure-material-textfield-outlined > input + span::after {
      transition-duration: 0.2s;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/static/forgot-password-page.vue